//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex'

import ThemeSwitch from '../../../../components/ThemeSwitch/ThemeSwitch'

import {i18nLocales} from '../../../../i18n'

export default {
  name: 'HomeHeader',
  components: { ThemeSwitch },
  computed: {
    ...mapState({
      locale: state => state.i18n.locale
    }),
    currentLocaleIcon () {
      return (i18nLocales[this.locale] || { icon: '' }).icon
    },
    localeName () {
      return i18nLocales[this.locale].localeName
    }
  },
  methods: {
    clickCustomService () {
      this.$store.dispatch('showCustomerService')
      // this.$store.dispatch('disConnectSocket')
      // console.log(this.$store.state.app)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeHeader/HomeHeader.vue